"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getFeedDay = function getFeedDay(date, moment) {
  var dateMoment = moment(date);
  var now = moment().startOf('day');
  var yesterday = moment(now).subtract(1, 'days');
  var isSameYear = now.isSame(dateMoment.format(), 'year');

  if (now.isSame(dateMoment, 'day')) {
    return 'ds-feed.today';
  }

  if (yesterday.isSame(dateMoment, 'day')) {
    return 'ds-feed.yesterday';
  }

  return dateMoment.format("dddd D MMMM".concat(isSameYear ? '' : ' YYYY'));
};

var _default = getFeedDay;
exports["default"] = _default;
//# sourceMappingURL=getFeedDay.js.map